export enum ErpType {
    SAP = 'SAP',
    ORACLE = 'ORACLE',
    D365 = 'D365',
    NETSUITE = 'NETSUITE',
    MYOB = 'MYOB',
    SAGE = 'SAGE',
    XERO = 'XERO',
    QUICKBOOKS = 'QUICKBOOKS',
    VIEWPOINT = 'VIEWPOINT',
    TECHONE = 'TECHONE',
    ACUMATICA = 'ACUMATICA',
    IMPORTED = 'IMPORTED',
    OTHER = 'OTHER'
}

export enum EventName {
    ShowLoading = 'showLoading',
    ShowAttention = 'showAttention',
    ShowTooltip = 'showTooltip',
    ShowConfirm = 'showConfirm',
    ConfirmResponse = 'confirmResponse',
    ConfirmAttention = 'confirmAttention',
    ShowSuccessMessage = 'showSuccessMessage',
    ErpAuthorized = 'erpAuthorized',
    ErpInterrupted = 'erpInterrupted',
    StatementExtractionStatus = 'statementExtractionStatus',
    ErpConnectionStatus = 'erpConnectionStatus',
    ErpExtractionProgress = 'erpExtractionProgress',
    SubscribeToSocketEvents = 'subscribeToSocketEvents',
}

export enum SocketEventType {
    StatementExtraction = 'StatementExtraction',
    ErpConnection = 'ErpConnection',
    ApTransactionExtraction = 'ApTransactionExtraction',
}

export enum DateFilterName {
    Date = 'Today',
    Week = 'This week',
    Month= 'This month',
    Year = 'This year',
    Custom = 'Custom date'
}

export enum UserRoleEnum {
    Admin = 'zerobs_admin',
    Member = 'member'
}

export enum AppPageEnum {
    Base = 'base',
    Dashboard = 'dashboard',
    Statements = 'statements',
    StatementCreating = 'statementCreating',
    StatementDetail = 'statementDetail',
    StatementHistory = 'statementHistory',
    Matchings = 'matchings',
    MatchingDetail = 'matchingDetail',
    ReconciliationActivity = 'reconciliationActivity',
    ReconciliationReport = 'reconciliationReport',
    MatchingActivityHistory = 'activityHistory',
    ERPIntegration = 'erpIntegration',
    ImportApTransactions = 'importApTransactions',
    EmailSettings = 'emailSettings',
}

export enum TooltipNameEnum {
    Match = 'match',
    PotentialMatch = 'potentialMatch',
    Duplicate = 'duplicate',
    NotMatch = 'notMatch',
    Ignore = 'ignore',
    
    ViewItem = 'viewItem',
    ResolveExtractionError = 'resolveExtractionError',
    ReviewMatching = 'reviewMatching',  // New enum for View Details button
    ExtractionStatus = 'extractionStatus',
    EditItem = 'editItem',
    CancelChanges = 'cancelChanges',
    SaveItem = 'saveItem',
    MatchItem = 'matchItem',
    UnmatchItem = 'unmatchItem',
    DeleteItem = 'deleteItem',
    DeleteItemManual = 'deleteItemManual',
    ArchiveItem = 'archiveItem',
    UnarchiveItem = 'unarchiveItem',
    IgnoreItem = 'ignoreItem',
    RestoreItem ='restoreItem',
    NoteItem ='noteItem',
    Save = 'save',
    RefreshItemStatus = 'refreshItemStatus',
    RefreshData = 'refreshData',
    IncludeArchived = 'includeArchived',
    ShowHideStatementDetailHeader = 'showHideStatementDetailHeader',
}

export enum MatchingAuditTrailEventEnum {
    CreateMatching = "CREATE_NEW_MATCHING",
    MatchNotMatch = "MATCH_NOT_MATCH_ITEM",
    MatchPotential = "MATCH_POTENTIAL_MATCH_ITEM",
    MatchMatch = "MATCH_MATCHED_ITEM",
    UnmatchMatch = "UNMATCH_MATCH_ITEM",
    UnmatchPotential = "UNMATCH_POTENTIAL_MATCH_ITEM",
    UnmatchMergedMatch = "UNMATCH_MERGED_MATCH_ITEM",
    MatchMergeMatch = "MATCH_MERGE_MATCHING_ITEM",
    IgnoreMatch = "IGNORE_MATCH_ITEM",
    IgnorePotentialMatch = "IGNORE_POTENTIAL_MATCH_ITEM",
    IgnoreDuplicate = "IGNORE_DUPLICATED_ITEM",
    IgnoreNotMatch = "IGNORE_NOT_MATCH_ITEM",
    RestoreItem = "RESTORE_ITEM",
    NoteItem = "NOTE_ITEM"
};